import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconStop = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 1.5,
			width: 14,
			height: 14
		})
	})
});
export { SvgIconStop as ReactComponent };
